export default __webpack_public_path__ + "static/media/AHS.7d10d1d8.mp3";